import { MarketplaceFilterMain, MarketplaceFilterWrapper } from "./MarketplaceFilter.styled";
import { CollectionsFilter } from "./CollectionsFilter";
import { PriceFilter } from "./PriceFilter";
import { CategoriesFilter } from "./CategoriesFilter";
import { SortFilter } from "./SortFilter";
import { MarketplaceFilterSearch } from "./MarketplaceFilterSearch";

const activeFilter = {
  NFTs: (
    <>
      <MarketplaceFilterMain>
        <PriceFilter />
        <CollectionsFilter />
        <CategoriesFilter />
        <SortFilter />
      </MarketplaceFilterMain>
      <MarketplaceFilterSearch />
    </>
  ),
  Collections: (
    <>
      <MarketplaceFilterMain>
        <CategoriesFilter />
        <SortFilter />
      </MarketplaceFilterMain>{" "}
      <MarketplaceFilterSearch />
    </>
  ),
  Creators: (
    <>
      <MarketplaceFilterSearch />
    </>
  ),
};

export const MarketplaceFilter = ({ activeTab }) => {
  return (
    <MarketplaceFilterWrapper>
      <div className='container'>
        <div className='filter_wrapper'>{activeFilter[activeTab]}</div>
      </div>
    </MarketplaceFilterWrapper>
  );
};
